import api from 'Services/api';

export default async function getRoles() {
  const roles = await api.get('/role').then((res) => res.data).catch((err) => err);
  return roles;
}
